import { HttpClient } from './HttpClient.js';


export const DispatchService = {
    
    async getDispatch() {
        return await HttpClient.get(`/dispatch`).then(response => response);
    }


}